import * as core from '../../../../../../../core'

import { query } from './maintenance-placeholder.query'

export const RESOURCE = {
  payload: {
    alias: 'maintenance.placeholder',
    description:
      'Placeholder widget for the Maintenance page. Not yet implemented.',
    name: 'Maintenance Placeholder',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
